"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _NumberFormatUtils = require("./NumberFormatUtils.js");

var _NumberFormatUtils2 = _interopRequireDefault(_NumberFormatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateUtils = {

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    textNotEmpty: function textNotEmpty(txt) {
        return txt.trim().length > 0;
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    textIsNumber: function textIsNumber(txt, locale) {
        try {
            return !isNaN(_NumberFormatUtils2.default.parse(txt, locale));
        } catch (err) {
            return !isNaN(txt);
        }
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    textIsNumberOrEmpty: function textIsNumberOrEmpty(txt) {
        return ValidateUtils.textIsNumber(txt) || !ValidateUtils.textNotEmpty(txt);
    },


    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    textIsPositiveNumberOrEmpty: function textIsPositiveNumberOrEmpty(txt, locale) {
        if (ValidateUtils.textIsNumber(txt)) {
            return _NumberFormatUtils2.default.parse(txt, locale) >= 0;
        } else {
            return !ValidateUtils.textNotEmpty(txt);
        }
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

};

exports.default = ValidateUtils;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/ValidateUtils.js
// module id = 1041
// module chunks = 0